module.exports = __webpack_public_path__ + "img/weather-fun.2d1c9826.jpg";